import React, { useEffect, useRef, useState } from 'react';
import { motion, useAnimation } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiStar, FiMessageCircle, FiChevronDown } = FiIcons;

const Testimonials = () => {
  const [visibleCount, setVisibleCount] = useState(6);
  const [isLoading, setIsLoading] = useState(false);
  
  const allTestimonials = [
    { name: "Sophia", date: "27th May 2025", content: "I just passed my test with Alpha Driving School! Olu is a fantastic instructor who makes you feel comfortable and confident from the very first lesson. His teaching style is clear, patient and encouraging. I couldn't have asked for a better instructor!", rating: 5 },
    { name: "Marcus", date: "14th April 2025", content: "Learning with Wura was an absolute pleasure. She's incredibly patient and has a knack for explaining complex maneuvers in simple terms. Thanks to her guidance, I passed my test with only 2 minor faults. Highly recommend Alpha Driving School!", rating: 5 },
    { name: "Priya", date: "3rd March 2025", content: "After failing twice with another instructor, I switched to Alpha and passed first time with Olu. The difference in teaching quality was night and day. Olu helped me overcome my nervousness and built my confidence gradually. Worth every penny!", rating: 5 },
    { name: "Jack", date: "8th May 2024", content: "I had lessons with Olu who was an amazing instructor. He was very patient and helped me to learn how to drive confidently. I would recommend him to anyone who wants to learn to drive!", rating: 5 },
    { name: "Elliot", date: "30th April 2024", content: "Olu is the best driving instructor I've had. He's very patient and has a great teaching method. He explains everything clearly and ensures you understand before moving on. I passed first time thanks to Olu!", rating: 5 },
    { name: "Chiara", date: "17th March 2024", content: "I cannot recommend Olu and Alpha Driving School enough! Olu is an amazing instructor, so patient, kind and reassuring. He has great teaching methods and is so knowledgeable about driving and all the test routes. Olu genuinely cares about his students and wants them to succeed and this shows in his teaching.", rating: 5 },
    { name: "Cailin", date: "29th February 2024", content: "I had Olu as a driving instructor and I could not recommend him enough. He was so patient and made me feel so calm while driving. He has a very calming presence which really helped me through my test. His teaching method is amazing and he always made sure I understood what I was doing. Thanks to him I passed first time!", rating: 5 },
    { name: "Emma", date: "15th January 2024", content: "Absolutely brilliant instructor! Olu was patient, professional, and built my confidence from day one. The lessons were well-structured and he explained everything in a way that was easy to understand. Passed first time with only 1 minor fault!", rating: 5 },
    { name: "Ryan", date: "22nd December 2023", content: "Wura is an exceptional instructor. Her calm demeanor and clear explanations made learning to drive so much easier than I expected. She was always punctual and professional. Highly recommend!", rating: 5 },
    { name: "Aisha", date: "8th November 2023", content: "After struggling with nerves, I found Alpha Driving School. Olu's patience and encouragement helped me overcome my anxiety. I passed my test today and couldn't be happier! Thank you so much!", rating: 5 },
    { name: "Tom", date: "25th October 2023", content: "Professional, reliable, and excellent instructor. Olu's teaching methods are top-notch. He focuses on safety while building confidence. Worth every penny!", rating: 5 },
    { name: "Sarah", date: "12th September 2023", content: "Wura made learning to drive enjoyable! Her positive attitude and patience were exactly what I needed. She adapts her teaching style to suit the individual. Passed first time!", rating: 5 },
    { name: "Mohammed", date: "30th August 2023", content: "Olu is an outstanding instructor. His knowledge of test routes and ability to identify areas for improvement is impressive. Thanks to his guidance, I passed with zero faults!", rating: 5 },
    { name: "Lily", date: "15th July 2023", content: "Best decision choosing Alpha Driving School! Wura is patient, thorough, and always makes time for extra practice. She built my confidence and helped me pass first time!", rating: 5 },
    { name: "James", date: "2nd June 2023", content: "Olu's teaching methods are excellent. He breaks down complex maneuvers into simple steps. His calm approach helped me through difficult situations. Highly recommended!", rating: 5 },
    { name: "Zara", date: "18th May 2023", content: "After failing with another school, I switched to Alpha. The difference was incredible! Olu identified my weaknesses and helped me improve quickly. Passed first time!", rating: 5 },
    { name: "Ben", date: "5th April 2023", content: "Wura is an amazing instructor! Very patient and understanding. She adapts to your learning pace and ensures you're comfortable before moving on. Great experience!", rating: 5 },
    { name: "Olivia", date: "22nd March 2023", content: "Olu is exceptional! His professionalism and patience made learning to drive stress-free. He's knowledgeable, punctual, and genuinely cares about his students' success.", rating: 5 },
    { name: "Daniel", date: "10th February 2023", content: "Fantastic instructor! Wura's calm approach and clear instructions made all the difference. She helped me build confidence and pass my test. Highly recommend!", rating: 5 },
    { name: "Grace", date: "28th January 2023", content: "Olu is the best driving instructor! His patience and encouragement helped me overcome my fears. He's professional, reliable, and an excellent teacher. Passed first time!", rating: 5 },
    { name: "Lucas", date: "15th December 2022", content: "Wura made learning to drive enjoyable and stress-free. Her teaching methods are effective, and she's always patient and encouraging. Great experience overall!", rating: 5 },
    { name: "Mia", date: "2nd November 2022", content: "Olu is an outstanding instructor! His knowledge and experience are evident in every lesson. He helped me pass first time with confidence. Highly recommended!", rating: 5 },
    { name: "Noah", date: "20th October 2022", content: "Best driving school! Wura is patient, professional, and an excellent teacher. She adapts to your learning style and ensures you're test-ready. Passed first time!", rating: 5 },
    { name: "Isabella", date: "8th September 2022", content: "Olu is exceptional! His calm approach and clear explanations made learning to drive so much easier. He's patient, professional, and genuinely cares about his students.", rating: 5 },
    { name: "Ethan", date: "25th August 2022", content: "Wura is an amazing instructor! Her positive attitude and patience made learning enjoyable. She helped me build confidence and pass my test first time. Highly recommend!", rating: 5 },
    { name: "Charlotte", date: "12th July 2022", content: "Olu is the best! His teaching methods are excellent, and he's always patient and encouraging. He helped me overcome my nerves and pass with confidence. Fantastic experience!", rating: 5 },
    { name: "William", date: "30th June 2022", content: "Wura is an exceptional instructor! Professional, reliable, and very patient. She adapts her teaching style to suit individual needs. Passed first time!", rating: 5 },
    { name: "Amelia", date: "18th May 2022", content: "Olu is outstanding! His knowledge of driving and test routes is impressive. He's patient, professional, and genuinely cares about his students' success. Highly recommended!", rating: 5 },
    { name: "Henry", date: "5th April 2022", content: "Best driving instructor! Wura's calm approach and clear instructions made learning to drive stress-free. She helped me build confidence and pass first time. Excellent!", rating: 5 }
  ];

  const visibleTestimonials = allTestimonials.slice(0, visibleCount);
  
  const loadMore = () => {
    setIsLoading(true);
    setTimeout(() => {
      setVisibleCount(prev => Math.min(prev + 6, allTestimonials.length));
      setIsLoading(false);
    }, 500);
  };

  const containerRef = useRef(null);
  const controls = useAnimation();

  useEffect(() => {
    const animateScroll = async () => {
      await controls.start({
        y: [0, -3000],
        transition: {
          y: { repeat: Infinity, repeatType: "loop", duration: 90, ease: "linear" }
        }
      });
    };
    animateScroll();

    const container = containerRef.current;
    if (container) {
      const handleMouseEnter = () => controls.stop();
      const handleMouseLeave = () => animateScroll();
      container.addEventListener('mouseenter', handleMouseEnter);
      container.addEventListener('mouseleave', handleMouseLeave);
      return () => {
        container.removeEventListener('mouseenter', handleMouseEnter);
        container.removeEventListener('mouseleave', handleMouseLeave);
      };
    }
  }, [controls]);

  return (
    <section className="py-20 bg-gray-50 dark:bg-gray-800 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4 transition-colors">
            What Our Students Say
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto transition-colors">
            Read reviews from our students who have successfully passed their driving tests with our instructors.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          {visibleTestimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.05 }}
              className="bg-white dark:bg-gray-900 rounded-xl p-6 shadow-md hover:shadow-lg transition-all duration-300 border border-gray-100 dark:border-gray-700"
            >
              <div className="flex items-center gap-1 mb-3">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <SafeIcon key={i} icon={FiStar} className="w-5 h-5 text-yellow-400 fill-current" />
                ))}
              </div>
              <div className="flex gap-3 items-start mb-4">
                <div className="mt-1 text-blue-600 dark:text-blue-400">
                  <SafeIcon icon={FiMessageCircle} className="w-5 h-5" />
                </div>
                <p className="text-gray-700 dark:text-gray-300 transition-colors leading-relaxed">
                  "{testimonial.content}"
                </p>
              </div>
              <div className="flex justify-between items-center">
                <div className="font-semibold text-gray-900 dark:text-white transition-colors">
                  {testimonial.name}
                </div>
                <div className="text-sm text-gray-500 dark:text-gray-400 transition-colors">
                  {testimonial.date}
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {visibleCount < allTestimonials.length && (
          <div className="text-center">
            <motion.button
              onClick={loadMore}
              disabled={isLoading}
              className="inline-flex items-center gap-2 bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700 transition-all duration-200 font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              {isLoading ? (
                <>
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  Loading...
                </>
              ) : (
                <>
                  <SafeIcon icon={FiChevronDown} className="w-5 h-5" />
                  Load More Reviews
                </>
              )}
            </motion.button>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-2 transition-colors">
              Showing {visibleCount} of {allTestimonials.length} reviews
            </p>
          </div>
        )}
      </div>
    </section>
  );
};

export default Testimonials;